<template lang="html">
  <div>
    <h1 style="text-align:center; font-size:2.3em; " class="mt-4">จัดการข้อมูลการประชุมครั้งที่ 2 ปี 2018</h1>
    <v-dialog v-model="dialog" max-width="850px">
      <v-btn slot="activator" color="primary" dark class="mb-2">เพิ่มการประชุมครั้งถัดไป</v-btn>
      <v-card>
        <v-container class="outerDiv">
          <v-layout row wrap>
            <v-flex xs12 md8 offset-md2>
              <div class="loginDiv" style="text-align:right;">
                <div class="centerDiv">
                  <img class="LogoInet" src="/static/img/icons/logo.jpg" alt="">
                </div>
                <h1 style="text-align:center; font-size:2.3em; " class="mb-4 mt-1">ข้อมูลการประชุมครั้งที่ 2 ปี 2018</h1>
                <v-layout row wrap class="pl-3 pr-3">
                  <v-flex xs6>
                    <h1 style="text-align:center">Value</h1>
                    <v-text-field hint="this_year" v-model="editedItem.year" class="input-group--focused" single-line></v-text-field>
                    <v-text-field hint="agenda_date" v-model="editedItem.date" class="input-group--focused" single-line></v-text-field>
                    <v-text-field hint="limit_person" v-model="editedItem.limitPerson" class="input-group--focused" single-line></v-text-field>
                    <v-text-field hint="location" v-model="editedItem.location" class="input-group--focused" single-line></v-text-field>
                    <v-text-field hint="presenter" class="input-group--focused" single-line></v-text-field>
                    <v-text-field hint="type" v-model="editedItem.type" class="input-group--focused" single-line></v-text-field>
                    <v-text-field hint="term" v-model="editedItem.term" class="input-group--focused" single-line></v-text-field>
                    <v-text-field hint="fix" v-model="editedItem.fix" class="input-group--focused" single-line></v-text-field>
                    <v-text-field hint="meetingName" value="Annual General Meet" class="input-group--focused" single-line></v-text-field>
                    <v-text-field hint="meetingName_th" v-model="editedItem.meetingNameTH" class="input-group--focused" single-line></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <h1 style="text-align:center">Detail</h1>
                    <v-text-field label="this_year" placeholder="ปีที่ประชุมผู้ถือหุ้น" disabled></v-text-field>
                    <v-text-field label="agenda_date" placeholder="วันที่ประชุมผู้ถือหุ้น" disabled></v-text-field>
                    <v-text-field label="limit_person" placeholder="จำนวนผู้ลงทะเบียนผู้ถือหุ้น(ขั้นต่ำ)" disabled></v-text-field>
                    <v-text-field label="location" placeholder="สถานที่ประชุมผู้ถือหุ้น" disabled></v-text-field>
                    <v-text-field label="presenter" placeholder="name of presenter" disabled></v-text-field>
                    <v-text-field label="type" placeholder="1=เสียงข้างมาก 2=เสียง 3 ใน 4" disabled></v-text-field>
                    <v-text-field label="term" placeholder="ครั้งที่" disabled></v-text-field>
                    <v-text-field label="fix" placeholder="วาระที่ต้องการใส่รูป" disabled></v-text-field>
                    <v-text-field label="meetingName" placeholder="ชื่อวาระประชุมภาษาอังกฤษ" disabled></v-text-field>
                    <v-text-field label="meetingName_th" placeholder="ชื่อการประชุมภาษาไทย" disabled></v-text-field>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">ยกเลิก</v-btn>
          <v-btn color="blue darken-1" flat @click.native="save">เพิ่มการประชุมครั้งถัดไป</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-data-table :headers="headers" :items="desserts" class="elevation-1">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.id }}</td>
        <td class="text-xs-left">{{ props.item.meetingNameTH }}</td>
        <td class="text-xs-left">{{ props.item.agendaDate }}</td>
        <td class="justify-right layout px-0">
          <v-btn icon class="mx-0" @click="editItem(props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteItem(props.item)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>
      <template slot="no-data">
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      year: '',
      date: '',
      person: '',
      location: '',
      presenter: '',
      type: '',
      term: '',
      fix: '',
      meetingName: '',
      meetingNameth: '',
      dialog: false,
      headers: [
        { text: '#', align: 'left', sortable: false, value: 'id' },
        { text: 'ชื่อการประชุมสามัญประจำปีผู้ถือหุ้น', value: 'meetingNameTH', sortable: false },
        { text: 'วัน เดือน ปี', sortable: false, value: 'agendaDate' },
        { text: 'Actions', value: 'name', sortable: false }
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        limitPerson: '',
        location: '',
        presenter: '',
        type: '',
        term: '',
        fix: '',
        meetingName: '',
        meetingNameTH: '',
        agendaDate: '',
        year: ''
      },
      defaultItem: {
        limitPerson: '',
        location: '',
        presenter: '',
        type: '',
        term: '',
        fix: '',
        meetingName: '',
        meetingNameTH: '',
        agendaDate: '',
        year: ''
      }
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.desserts = [
        {
          id: 1,
          limitPerson: '25',
          meetingNameTH: 'การประชุมสามัญผู้ถือหุ้นประจำปี 2561 ครั้งที่ 2',
          agendaDate: '23 เมษายน 2561',
          year: '2561'
        },
        {
          id: 2,
          limitPerson: '25',
          meetingNameTH: 'การประชุมสามัญผู้ถือหุ้นประจำปี 2561 ครั้งที่ 3',
          agendaDate: '18 ตุลาคม 2561',
          year: '2561'
        },
        {
          id: 3,
          limitPerson: '25',
          meetingNameTH: 'การประชุมสามัญผู้ถือหุ้นประจำปี 2562 ครั้งที่ 1',
          agendaDate: '3 มีนาคม 2562',
          year: '2562'
        },
        {
          id: 4,
          limitPerson: '25',
          meetingNameTH: 'การประชุมสามัญผู้ถือหุ้นประจำปี 2562 ครั้งที่ 2',
          agendaDate: '5 พฤษภาคม 2562',
          year: '2562'
        },
        {
          id: 5,
          limitPerson: '25',
          meetingNameTH: 'การประชุมสามัญผู้ถือหุ้นประจำปี 2562 ครั้งที่ 3',
          agendaDate: '11 พฤศจิกายน 2562',
          year: '2562'
        },
        {
          id: 6,
          limitPerson: '25',
          meetingNameTH: 'การประชุมสามัญผู้ถือหุ้นประจำปี 2563 ครั้งที่ 1',
          agendaDate: '12 เมษายน 2563',
          year: '2563'
        }
      ]
    },
    editItem (item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      const index = this.desserts.indexOf(item)
      this.$swal({
        title: '',
        text: 'คุณต้องการลบรายการที่เลือกอย่างถาวรหรือไม่',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ตกลง',
        // confirmButtonColor: 'blue',
        // cancelButtonColor: 'green',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        reverseButtons: true
      }).then((result) => {
        if (!result.value) {
          this.$swal('ข้อมูลถูกลบ', 'คุณได้ลบข้อมูลวาระสำเร็จแล้ว', 'success') && this.desserts.splice(index, 1)
        }
      })
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem)
      } else {
        this.desserts.push(this.editedItem)
      }
      this.close()
    }
  }
}
</script>

<style lang="css" scoped>
.LogoInet{
  width: 70%
}
.outerDiv{
  padding: 3em 1em;
}
.centerDiv{
  display: flex;
  align-items: center;
  justify-content: center;
}
@media only screen and (max-width: 600px){
  .loginLogo{
    width: 100%
  }
}
.elevation-1{
  margin: 15px;
}
td{
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/ManageMeeting.vue